@if (formGroup) {
  <form [formGroup]="formGroup" class="grid grid-cols-2 gap-3">
    <em-select formControlName="operator" [subscriptSizing]="'dynamic'">
      <em-option [value]="null"> </em-option>
      @for (operator of operators; track $index) {
        <em-option [value]="operator.name">
          {{ 'G_FILTER_' + operator.name.toUpperCase() + '_VALUE' | translate }}
        </em-option>
      }
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-select>

    <em-input
      formControlName="days"
      [subscriptSizing]="'dynamic'"
      [step]="1"
      type="number"
      [label]="'G_FILTER_PRICE_CHANGES_DAYS_INPUT_PLACEHOLDER' | translate"
    >
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-input>
  </form>
}
